export const formatBucketLink = (link?: string) => {
  if (!link) return undefined;

  return `https://storage.googleapis.com/${process.env.UPLOADS_BUCKET_NAME}/${link}`;
};
